import React, { useState } from "react";

function Search({ getUsersBySearch }) {
  let [searchValue, setSearchValue] = useState("");
  return (
    <>
      <div style={{ marginTop: "30px" }}>
        <input
          type="text"
          style={{ border: "2px solid #F0BA4A" }}
          placeholder="Enter Search Query..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <button
          onClick={() => { getUsersBySearch(searchValue)}}
          style={{
            backgroundColor: "#F0BA4A",
            color: "white",
            border: "none",
            height: "30px",
          }}
        >
          Search
        </button>
      </div>
    </>
  );
}

export default Search;
